import { render } from "./index.vue?vue&type=template&id=2949f93f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=2949f93f&scoped=true&lang=scss"

import exportComponent from "/Users/wuyuanfujie/front-end-saas-pure-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2949f93f"]])

export default __exports__